import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Card, Typography, message } from "antd";
import { UserOutlined, LockOutlined, SafetyOutlined } from "@ant-design/icons";
import LoginAPI from "../../Redux/APIs/login";
import { verifyMfaLogin } from "../../Redux/APIs/mfa";

const { Title, Text } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mfaStep, setMfaStep] = useState(false);
  const [tempToken, setTempToken] = useState(null);
  const [mfaCode, setMfaCode] = useState("");

  const onFinish = (values) => {
    setLoading(true);
    dispatch(
      LoginAPI(
        values.email,
        values.password,
        (data) => {
          setLoading(false);
          if (data.status === "mfa_required") {
            setTempToken(data.tempToken);
            setMfaStep(true);
            return;
          }
          navigate("/home");
        },
        () => {
          setLoading(false);
        }
      )
    );
  };

  const onMfaSubmit = async () => {
    if (!mfaCode || mfaCode.length !== 6) {
      message.error("Please enter a 6-digit code");
      return;
    }
    setLoading(true);
    try {
      const response = await verifyMfaLogin(tempToken, mfaCode);
      const data = response.data;
      localStorage.setItem("token", data.webToken);
      if (data.data) {
        localStorage.setItem("adminData", JSON.stringify(data.data));
        dispatch({ type: "SET_ADMIN", payload: data.data });
      }
      navigate("/home");
    } catch (err) {
      message.error(err.response?.data?.message || "Invalid MFA code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #0F1543 0%, #00AFEE 100%)",
      }}
    >
      <Card
        style={{
          width: 400,
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          borderRadius: 12,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <img
            src={require("../../Assets/images/Moveinout-Logo.svg").default || require("../../Assets/images/Moveinout-Logo.svg")}
            alt="Moveinout-Logo"
            style={{ height: 40, marginBottom: 16 }}
          />
          <Title level={3} style={{ margin: 0 }}>
            {mfaStep ? "Two-Factor Authentication" : "Admin Login"}
          </Title>
        </div>

        {!mfaStep ? (
          <Form name="login" onFinish={onFinish} layout="vertical" size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Email" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Sign In
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div>
            <Text style={{ display: "block", marginBottom: 16, textAlign: "center" }}>
              Enter the 6-digit code from your authenticator app
            </Text>
            <Input
              prefix={<SafetyOutlined />}
              placeholder="000000"
              maxLength={6}
              value={mfaCode}
              onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, ""))}
              onPressEnter={onMfaSubmit}
              size="large"
              style={{ marginBottom: 16, textAlign: "center", letterSpacing: 8, fontSize: 20 }}
            />
            <Button type="primary" block loading={loading} onClick={onMfaSubmit} size="large">
              Verify
            </Button>
            <Button
              type="link"
              block
              onClick={() => { setMfaStep(false); setTempToken(null); setMfaCode(""); }}
              style={{ marginTop: 8 }}
            >
              Back to login
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Login;
